import { useEffect } from "react";
import { motion, useMotionTemplate, useMotionValue } from "framer-motion";
import { useTheme, ThemeProvider } from "../context/ThemeContext";

const Layout = ({ children }: { children: React.ReactNode }) => {
  let mouseX = useMotionValue(0);
  let mouseY = useMotionValue(0);
  const { darkMode } = useTheme();

  function handleMouseMove({ clientX, clientY }: React.MouseEvent) {
    mouseX.set(clientX);
    mouseY.set(clientY);
  }

  return (
    <div className="relative min-h-screen" onMouseMove={handleMouseMove}>
      <div className="fixed inset-0 z-[-5]">
        {/* Background gradients */}
        <div className="absolute inset-0 bg-gradient-to-tr from-background via-blue-500/10 to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_500px_at_70%_200px,rgba(120,119,198,0.1),transparent)]" />

        {/* Grid - only in dark mode */}
        {darkMode && (
          <div
            id="scroll"
            className="absolute inset-0 bg-[linear-gradient(to_right,#2d3c61_1px,transparent_1px),linear-gradient(to_bottom,#2d3c61_1px,transparent_1px)] bg-[size:48px_48px] [mask-image:radial-gradient(ellipse_70%_100%_at_58%_0%,#4d4dff_0%,transparent_110%)]"
          />
        )}

        {/* Spotlight effect */}
        <motion.div
          className="pointer-events-none absolute inset-0"
          style={{
            background: useMotionTemplate`
              radial-gradient(
                400px circle at ${mouseX}px ${mouseY}px,
                rgba(14, 165, 233, 0.15),
                transparent 80%
              )
            `,
          }}
        />
      </div>
      {children}
    </div>
  );
};

export default Layout;
